module.exports = "/components/components/premiumTrialEndModal-6bf4b3.html";